module.exports = __webpack_public_path__ + "static/1319314684.5e1d4e52.jpg";